import { Box, Text } from '../../../primitives';
import { styled } from '../../../theme';
import { Column } from '../../Column';
import { Row } from '../../Row';
import type { NumberedStepVariant } from './Step';

type VariantProps = {
	variant?: NumberedStepVariant;
};

export const Wrapper = styled(Row)<VariantProps>`
	padding: ${({ theme, variant }) =>
		variant === 'card' ? `${theme.space.sm}px` : `${theme.space.sm}px 0`};
	gap: ${({ theme }) => theme.space.sm}px;
	align-items: ${({ variant }) => (variant === 'card' ? 'flex-start' : 'center')};
	border-radius: ${({ theme, variant }) => (variant === 'card' ? `${theme.rounding.md}px` : 0)};
	background: ${({ theme, variant }) =>
		variant === 'card' ? theme.color.greenSurface.base : theme.color.transparent.base};
`;

export const Circle = styled(Box)<VariantProps>`
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	height: ${({ theme, variant }) =>
		`${variant === 'card' ? theme.space.lg + theme.space.xs : theme.space.lg + theme.space.sm}px`};
	width: ${({ theme, variant }) =>
		`${variant === 'card' ? theme.space.lg + theme.space.xs : theme.space.lg + theme.space.sm}px`};
	background-color: ${({ theme, variant }) =>
		variant === 'card' ? theme.color.green.base : theme.color.lightGreen.base};
	flex: 0 0 auto;
`;

const BaseCircleText = styled(Text).attrs((props) => ({
	...props,
	size: 'lg',
	style: 'bold',
}))``;

export const CircleText = styled(BaseCircleText)<VariantProps>`
	color: ${({ theme, variant }) =>
		variant === 'card' ? theme.color.white.base : theme.color.green.base};
`;

export const Content = styled(Column)`
	min-width: 0;
	gap: ${({ theme }) => theme.space.xs}px;
`;

export const HeadingText = styled(Text).attrs((props) => ({
	...props,
	style: 'bold',
	element: 'span',
}))`
	display: block;
	color: ${({ theme }) => theme.color.darkGray.base};
`;
